import { Card, CardBody, CardHeader } from '@heroui/react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { PatientDates } from '@/patient-app-common/hooks/usePatientDates';
import { Patient } from '@/patient-app-common/types/Patient';

import { EndSurveyCard } from '../surgical/EndSurveyCard';

interface ChronicProgramProps {
  patient: Patient;
  patientDates: PatientDates;
}

export function ChronicProgram({ patient, patientDates }: ChronicProgramProps) {
  const { t } = useTranslation('home');
  const { firstName, programDuration, othersUsingApp } = patient;
  const headerText = othersUsingApp
    ? t('common.text.greeting_name_indirect', { firstName })
    : t('common.text.greeting_name', { firstName });
  const { signupDate, completedDate, startOfDayInHospitalTz } = patientDates;

  const daysInProgram =
    dayjs(startOfDayInHospitalTz).diff(dayjs(signupDate), 'days') + 1;

  if (dayjs(startOfDayInHospitalTz).isSameOrAfter(dayjs(completedDate))) {
    return (
      <>
        <Card shadow="none" className="bg-transparent px-0">
          <CardHeader className="px-0">
            <h1 className="text-2xl">{headerText}</h1>
          </CardHeader>
          <CardBody className="px-0">
            <h2>{t('chronicprogram.countdown_end')}</h2>
            <p className="font-light">{t('endcard.description')}</p>
          </CardBody>
        </Card>
        <EndSurveyCard
          endSurveyId={patient.endSurveyId}
          endSurveyCompleted={patient.endSurveyCompleted}
        />
      </>
    );
  }

  return (
    <Card shadow="none" className="bg-transparent px-0">
      <CardHeader className="px-0">
        <h1 className="text-2xl">{headerText}</h1>
      </CardHeader>
      <CardBody className="px-0">
        <h2>
          {t('chronicprogram.countdown', { daysInProgram, programDuration })}
        </h2>
        <p className="font-light">{t('postopcard.description')}</p>
      </CardBody>
    </Card>
  );
}
